module.exports = __webpack_public_path__ + "img/6.1d6cf38f.png";